import { render, staticRenderFns } from "./TagMiscInfoLink.vue?vue&type=template&id=77aa4ac0"
import script from "./TagMiscInfoLink.vue?vue&type=script&lang=js"
export * from "./TagMiscInfoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports